import { ACDSessionManager } from '@nice-devone/core-sdk';
import { logger } from '../../../utils/logger';
import { cxoneSdkState } from '../state';

const SETTLE_MS = 500;

function isSuccessResponse(response: unknown): boolean {
  return Boolean(response && !('errorCode' in (response as object)));
}

export async function endSessionViaSdk(): Promise<boolean> {
  const acdSession = ACDSessionManager.instance;

  try {
    logger.debug('[CXone SDK] Strategy 1: Trying SDK endSession method...');
    const response = await acdSession.endSession({
      forceLogoff: true,
      endContacts: true,
      ignorePersonalQueue: true,
    });

    logger.debug('[CXone SDK] SDK endSession response:', response);

    if (isSuccessResponse(response)) {
      logger.debug('[CXone SDK] Session ended via SDK successfully');
      await new Promise((resolve) => setTimeout(resolve, SETTLE_MS));
      return true;
    }
  } catch (sdkError) {
    logger.debug('[CXone SDK] SDK endSession failed:', sdkError);
  }

  return false;
}

export async function joinAndEndSessionViaSdk(): Promise<boolean> {
  const acdSession = ACDSessionManager.instance;
  const agentId = cxoneSdkState.storedUserInfo?.icAgentId;

  if (!agentId) {
    return false;
  }

  try {
    logger.debug('[CXone SDK] Strategy 2: Trying SDK joinSession to take over existing session...');
    const joinResponse = await acdSession.joinSession({
      agentId: Number(agentId),
    });

    logger.debug('[CXone SDK] joinSession response:', joinResponse);

    if (!isSuccessResponse(joinResponse)) {
      return false;
    }

    logger.debug('[CXone SDK] Successfully joined existing session, now ending it...');
    await new Promise((resolve) => setTimeout(resolve, SETTLE_MS));

    const endResponse = await acdSession.endSession({
      forceLogoff: true,
      endContacts: true,
      ignorePersonalQueue: true,
    });

    logger.debug('[CXone SDK] endSession after join response:', endResponse);

    if (isSuccessResponse(endResponse)) {
      logger.debug('[CXone SDK] Session ended successfully after join');
      await new Promise((resolve) => setTimeout(resolve, SETTLE_MS));
      return true;
    }
  } catch (joinError) {
    logger.debug('[CXone SDK] joinSession failed:', joinError);
  }

  return false;
}

export function getForceLogoutConfig(): {
  baseUrl?: string;
  authToken?: string;
  agentId?: string;
} {
  const acdSession = ACDSessionManager.instance;

  return {
    baseUrl: acdSession.cxOneConfig?.acdApiBaseUri,
    authToken: acdSession.accessToken,
    agentId: cxoneSdkState.storedUserInfo?.icAgentId,
  };
}
